﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import type { LogoutPageCustomizations } from "~base/Components/Pages/Account/Logout";
import type { User } from "~base/Services/API/Account/Model";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default {
    requiresUser: true, // Required to get the IDP end session endpoint.

    getState: (user: User) => {
        if (user?.AdditionalProperties) {
            const stateValue = user.AdditionalProperties.find(
                (x) => x.Key == "idp_end_session_endpoint"
            )?.Value as string;
            if (stateValue) {
                return btoa(stateValue);
            }
        }

        return null;
    },
} as LogoutPageCustomizations;
